// extracted by mini-css-extract-plugin
module.exports = {"Logo":"RegisterForm_Logo__23CBP","btn":"RegisterForm_btn__3W0sv"};